import { INFERENCE_COMPUTE_MS_HEADER } from '../config/digisakaGptInference';

export const COMPUTE_USAGE_EVENT = 'digisaka:compute-usage';

/** Apply one server-reported duration (ms) to the local budget via AuthContext listener. */
export function applyComputeMsFromHeaderValue(raw: string | null | undefined): void {
  if (raw == null || raw === '') return;
  const ms = parseInt(String(raw), 10);
  if (!Number.isFinite(ms) || ms <= 0) return;
  window.dispatchEvent(new CustomEvent(COMPUTE_USAGE_EVENT, { detail: ms }));
}

/**
 * Reads `X-Digisaka-Compute-Ms` from a metered inference `fetch` response and broadcasts it so
 * `AuthProvider` can decrement the sidebar budget without calling `/auth/me` again.
 */
export function notifyInferenceComputeUsage(res: Response): void {
  applyComputeMsFromHeaderValue(res.headers.get(INFERENCE_COMPUTE_MS_HEADER));
}

/** Axios (and similar) responses: header may be exposed under lowercase keys. */
export function notifyComputeUsageFromAxiosHeaders(
  headers: { get?: (n: string) => string | undefined | null } | Record<string, string | number | undefined> | undefined
): void {
  if (!headers) return;
  if (typeof (headers as { get?: (n: string) => unknown }).get === 'function') {
    const g = (headers as { get: (n: string) => unknown }).get.bind(headers);
    const raw =
      g(INFERENCE_COMPUTE_MS_HEADER) ??
      g('X-Digisaka-Compute-Ms') ??
      g('x-digisaka-compute-ms');
    applyComputeMsFromHeaderValue(raw == null ? null : String(raw));
    return;
  }
  const h = headers as Record<string, string | number | undefined>;
  const raw =
    h[INFERENCE_COMPUTE_MS_HEADER] ??
    h['X-Digisaka-Compute-Ms'] ??
    h['x-digisaka-compute-ms'];
  applyComputeMsFromHeaderValue(raw == null ? null : String(raw));
}
